// extracted by mini-css-extract-plugin
export default {"container__main":"Template_container__main__JjLXK"};